import {inject} from '@angular/core';
import {CanActivateFn} from '@angular/router';
import {AuthService} from './services/auth.service';

export function authGuard(): CanActivateFn {
  return () => {
    const authService: AuthService = inject(AuthService);
    if (authService.isLoggedIn()) {
      return true;
    }
    authService.startAuthentication();
    return false;
  };
}
